(function() {
jQuery(function() {
  return $(document).on("click", ".licence_number_with_do_not_know input[data-do-not-know]", function(event) {
    var $licence_number_field, checked;
    checked = $(event.target).prop("checked");
    $licence_number_field = $(event.target).closest(".licence_number_with_do_not_know").find("input[data-licence-number]");
    return $licence_number_field.prop("disabled", checked);
  });
});

}).call(window);
